import React from 'react';

import classNames from 'classnames';

import 'components/Type';

import './styles.css';

const LinkText = ({children, onClick, className}: any) => {
  return (
    <span className={classNames('LinkText', className)} onClick={onClick}>
      {children}
    </span>
  );
};

export default LinkText;
